<template>
  <div id="promo">
    <BottomBar />
    <Empty v-if="!imgs.length" :loading="true" />
    <img v-for="(item, index) in imgs" :key="index" :src="item" />
  </div>
</template>

<script>
import BottomBar from "@/components/public/footer"
import Empty from "@/components/public/Empty"
export default {
  name: "promo",
  components: {
    BottomBar,
    Empty,
  },
  data() {
    return {
      imgs: [],
      data: null,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  watch: {
    user: function (val) {
      if (val.user_id && this.data && this.$store.state.isWechat) {
        this.wxShare()
      }
    },
    data: function (val) {
      if (this.user.user_id && val && this.$store.state.isWechat) {
        this.wxShare()
      }
    },
  },
  methods: {
    async getData() {
      try {
        const { value_1, value_2 } = await this.$api.api.CUSTOM("promo_" + this.$route.params.id)
        this.data = JSON.parse(value_1)
        this.imgs = value_2.split(",")
        document.title = this.data.pageTitle
      } catch (error) {
        this.$router.push("/")
      }
    },
    wxShare() {
      let { inviteTitle, desc } = this.data
      const title = this.user.name + inviteTitle
      const imgUrl = window.logo2019
      const link = `${window.homePageUrl}${this.$route.path}?friend=${this.$store.state.user.user_id}`

      wx.ready(() => {
        wx.updateAppMessageShareData({
          title,
          desc,
          link,
          imgUrl,
        })
        wx.updateTimelineShareData({
          title,
          link,
          imgUrl,
        })
      })
    },
  },
  created() {
    this.getData()
  },
}
</script>

<style lang="scss" scoped>
// @import "../../../static/css/public.scss";
#promo {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  img {
    width: 100%;
  }
}
</style>
